import { Component } from 'react';
import classes from './link_button.less';

type Props = {
  label: string;
  url: string;
  className?: string;
};

export default class LinkButton extends Component<Props> {
  render() {
    const { label, url, className } = this.props;
    return (
      <div className={className}>
        <a href={url} target="_blank" rel="noopener">
          <button className={classes.button}>{label}</button>
        </a>
      </div>
    );
  }
}
